export default "__VITE_ASSET__Dm1NsSM2__"